import { Box } from "@mui/material";
import { useState } from "react";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { salesManagement } from "../../../config";

const base_url = salesManagement.uri;
const PurchaseOrdersAuditsQuery = `{
 allPurchaseOrdersAudit {
    auditDate
    auditId
    branchId
    cancelled
    changedColumns
    changedData
    clientIP
    companyId
    dbUser
    deliveryStatus
    inventoryUpdatedBy
    inventoryUpdatedByUsername
    inventoryUpdatedDate
    isCredit
    isInventoryPosted
    newData
    oldData
    operation
    outstandingBalance
    paymentStatus
    purchaseOrderId
    reason
    regionId
    reversed
    source
    updatedBy
    updatedByUsername
    updatedDate
    userId
    username
    vendorId
  }
  }
`;
const actions = {
  entity: "PurchaseOrderAudits",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button:false,
    permission: "ActivatePermission",
    modelName: "colorIds",
    inputObjectName: "bulkActivateDeactivateColor",
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Inventory Details"
  },
  showStatus: true,
};
const ignore = [ "branchId", "changedColumns","cancelled","deliveryStatus","updatedBy","inventoryUpdatedBy","inventoryUpdatedDate", "clientIP", "companyId", "dbUser",  "inventoryUpdatedBy", "productId", "regionId", "source", "userId", "newData", "oldData", "purchaseOrderItemsId" ,"reason"];

function PurchaseOrdersAuditsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  return (
    <Box m="2px">
      <DynamicTable
        title="Purchase Orders Audits"
        subtitle="Manage purchase orders audits"
        // FormComponent={ColorForm}
        query={PurchaseOrdersAuditsQuery}
        ignoreFields={ignore}
        base_url={base_url}
        actions={actions}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        getRowId={(row) => row.auditId}

      />
    </Box>
  );
}

export default PurchaseOrdersAuditsTable;
